import React, { useState, useEffect } from 'react';
import Avatar from '@material-ui/core/Avatar';
import { Button } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Icon from '@material-ui/core/Icon';

import ImageUpload from './ImageUpload';
import { storage, auth, db } from './firebase';
import './Profile.css';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
  tab: {
    flexGrow: 1,
  },
}));

function Profile({ username, email, user }) {
  const [image, setImage] = useState(null);
  const [petName, setPetName] = useState('');
  const [petBirthday, setPetBirthday] = useState('');
  const [petAge, setPetAge] = useState('');
  const [petSpecies, setPetSpecies] = useState('');
  const [petColor, setPetColor] = useState('');
  const [petWeight, setPetWeight] = useState('');
  const [petTag, setPetTag] = useState('');
  const [userDetail, setUserDetail] = useState('');
  const [docId, setDocId] = useState('');
  const [petInfo, setPetInfo] = useState(false);

  const dispatch = useDispatch();
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    const fileRef = storage.ref(`avatars/${email}-avatar.png`);
    if (fileRef) {
      fileRef.getDownloadURL().then(onResolve);

      function onResolve(foundURL) {
        setImage(foundURL);
      }
    }

    db.collection('petprofile').onSnapshot((snapshot) => {
      snapshot.docs.map((doc) => {
        if (email === doc.data().userEmail) {
          console.log(
            '----email:',
            doc.data().userEmail,
            doc.data().zipCode,
            doc.data(),
            doc.id
          );
          setUserDetail(doc.data());
          setDocId(doc.id);
        }
      });
      // if(doc.data())
    });
  }, []);

  const addImage = () => {
    document
      .getElementById('files')
      .addEventListener('change', handleChangeAvatar, false);
    document.getElementById('files').click();
  };
  const handleChangeAvatar = (e) => {
    if (e.target.files.length) {
      const files = e.target.files;
      imageUpload(files);
    }
  };
  const Update = () => {
    if (email === userDetail.userEmail) {
      {
        petName &&
          db.collection('petprofile').doc(docId).update({
            petName: petName,
          });
      }
      {
        petBirthday &&
          db.collection('petprofile').doc(docId).update({
            petBirthday: petBirthday,
          });
      }
      {
        petAge &&
          db.collection('petprofile').doc(docId).update({
            petAge: petAge,
          });
      }
      {
        petSpecies &&
          db.collection('petprofile').doc(docId).update({
            petSpecies: petSpecies,
          });
      }
      {
        petColor &&
          db.collection('petprofile').doc(docId).update({
            petColor: petColor,
          });
      }
      {
        petWeight &&
          db.collection('petprofile').doc(docId).update({
            petWeight: petWeight,
          });
      }
      {
        petTag &&
          db.collection('petprofile').doc(docId).update({
            petTag: petTag,
          });
      }
    } else {
      db.collection('petprofile').add({
        // userName: userName,
        userEmail: email,
        petName: petName,
        petBirthday: petBirthday,
        petAge: petAge,
        petSpecies: petSpecies,
        petColor: petColor,
        petWeight: petWeight,
        petTag: petTag,
      });
    }

    // db.collection('petprofile').add({
    //   // timestamp: firebase.firestore.FieldValue.serverTimestamp(),

    //   petName: petName,
    //   petBirthday: petBirthday,
    //   petAge: petAge,
    //   petSpecies: petSpecies,
    //   petColor: petColor,
    //   petWeight: petWeight,
    //   petTag: petTag,
    // });

    alert("It's been updated!");
  };
  const imageUpload = (image) => {
    const uploadTask = storage.ref(`avatars/${email}-avatar.png`).put(image[0]);
    uploadTask.on(
      'state_changed',
      (snapshot) => {
        // const progress = Math.round(
        //   (snapshot.bytesTransfeered / snapshot.totalBytes) * 100
        // );
      },
      (error) => {
        console.log(error);
      },
      () => {
        storage
          .ref(`avatars/${email}-avatar.png`)
          .getDownloadURL()
          .then((url) => {
            setImage(url);
          });
      }
    );
  };
  const onEdit = () => {
    {
      !petInfo ? setPetInfo(true) : setPetInfo(false);
    }
  };
  return (
    <div className='Profile' style={{ position: 'relative', width: '100%' }}>
      {/* <br></br> */}
      <div style={{ display: 'block' }}>
        <div
          style={{
            display: 'flex',
            // justifyContent: 'center',
            paddingTop: '5%',
          }}>
          <aside className='petlabel'>
            <label style={{ fontWeight: 'bold' }}> Name </label>
          </aside>
          <h4
            style={{
              width: '38%',
              paddingLeft: '5%',
              textAlign: 'start',
              color: '#6b7dde',
              fontSize: '16px',
            }}>
            {userDetail.petName}
          </h4>

          <button style={{ width: '80px' }} onClick={() => onEdit()}>
            Edit Profile
          </button>
        </div>
        <div
          style={{
            display: 'flex',
            // justifyContent: 'center',
            paddingTop: '3%',
          }}>
          <aside style={{ textAlign: 'start' }}>
            <label style={{ color: 'rgb(189, 189, 189)' }}>
              Basic Information
            </label>
          </aside>
        </div>
        <div
          style={{
            display: 'flex',
            // justifyContent: 'center',
            paddingTop: '3%',
          }}>
          <div style={{ display: 'flex', width: '23%' }}>
            <aside className='petlabel' style={{ fontWeight: 'bold', width: '38%'}}>
              Birthday
            </aside>
            <h4
              style={{
                width: '30%',
                paddingLeft: '5%',
                textAlign: 'start',
                color: '#6b7dde',
                fontSize: '16px',
              }}>
              {userDetail.petBirthday}
            </h4>
          </div>
          <div style={{ display: 'flex', width: '20%' }}>
            <aside className='petlabel' style={{ fontWeight: 'bold', width: '38%'}}>
              Age
            </aside>
            <h4
              style={{
                width: '30%',
                paddingLeft: '5%',
                textAlign: 'start',
                color: '#6b7dde',
                fontSize: '16px',
              }}>
              {userDetail.petAge}
            </h4>
          </div>

          <div style={{ display: 'flex', width: '20%' }}>
            <aside className='petlabel' style={{ fontWeight: 'bold', width: '38%'}}>
              Species
            </aside>
            <h4
              style={{
                width: '30%',
                paddingLeft: '5%',
                textAlign: 'start',
                color: '#6b7dde',
                fontSize: '16px',
              }}>
              {userDetail.petSpecies}
            </h4>
          </div>
        </div>
        {/* <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            paddingTop: '4%',
          }}>
          <aside className='petlabel'>Age: </aside>
          <p style={{ width: '30%', paddingLeft: '5%', textAlign: 'start' }}>
            {userDetail.petAge}
          </p>
        </div> */}
        {/* <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            paddingTop: '4%',
          }}>
          <aside className='petlabel'>Species:</aside>
          <p style={{ width: '30%', paddingLeft: '5%', textAlign: 'start' }}>
            {userDetail.petSpecies}
          </p>
        </div> */}
        <div
          style={{
            display: 'flex',
            // justifyContent: 'center',
            paddingTop: '3%',
          }}>
          <div style={{ display: 'flex', width: '23%' }}>
            <aside className='petlabel' style={{ fontWeight: 'bold', width: '38%'}}>
              Color
            </aside>
            <h4
              style={{
                width: '30%',
                paddingLeft: '5%',
                textAlign: 'start',
                color: '#6b7dde',
                fontSize: '16px',
              }}>
              {userDetail.petColor}
            </h4>
          </div>

          <div style={{ display: 'flex', width: '20%' }}>
            <aside className='petlabel' style={{ fontWeight: 'bold', width: '38%'}}>
              Weight
            </aside>
            <h4
              style={{
                width: '30%',
                paddingLeft: '5%',
                textAlign: 'start',
                color: '#6b7dde',
                fontSize: '16px',
              }}>
              {userDetail.petWeight}
            </h4>
          </div>

          <div style={{ display: 'flex', width: '20%' }}>
            <aside className='petlabel' style={{ fontWeight: 'bold', width: '38%'}}>
              Tag
            </aside>
            <h4
              style={{
                width: '30%',
                paddingLeft: '5%',
                textAlign: 'start',
                color: '#6b7dde',
                fontSize: '16px',
                paddingBottom: '3%',
              }}>
              {userDetail.petTag}
            </h4>
          </div>
        </div>
        {/* <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            paddingTop: '4%',
          }}>
          <aside className='petlabel'>Weight:</aside>
          <p style={{ width: '30%', paddingLeft: '5%', textAlign: 'start' }}>
            {userDetail.petWeight}
          </p>
        </div> */}
        {/* <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            paddingTop: '4%',
            paddingBottom: '5%',
          }}>
          <aside className='petlabel'>Tag:</aside>
          <p style={{ width: '30%', paddingLeft: '5%', textAlign: 'start' }}>
            {userDetail.petTag}
          </p>
        </div> */}
      </div>
      <br></br>
      <hr style={{ borderBottom: 'groove', borderTopStyle: 'none' }}></hr>
      {/* <div style={{width:'48%', marginLeft:'30%'}}>
        <ImageUpload username={username} useremail={email} />
      </div> */}

      {petInfo && (
        <form
          className={classes.root}
          style={{ width: '100%' }}
          noValidate
          autoComplete='off'>
          <div style={{ display: 'flex', paddingTop: '5%', margin: '0px' }}>
            <p style={{ color: 'rgb(189, 189, 189)' }}> Pet Information </p>
          </div>

          <div
            style={{
              display: 'flex',
              width: '100%',
              paddingTop: '3%',
              margin: '0',
            }}>
            <label className='petformlabel' style={{ width: '25%' }}>
              Name
            </label>
            <input
              className='petform'
              value={petName}
              placeholder='Name'
              onChange={(e) => {
                setPetName(e.target.value);
              }}
            />
          </div>
          <div
            style={{
              display: 'flex',
              width: '100%',
              paddingTop: '3%',
              margin: '0',
            }}>
            <label className='petformlabel' style={{ width: '25%' }}>
              Birthday
            </label>
            <input
              value={petBirthday}
              placeholder='Birthday'
              onChange={(e) => {
                setPetBirthday(e.target.value);
              }}
              className='petform'
            />
          </div>
          <div
            style={{
              display: 'flex',
              width: '100%',
              paddingTop: '3%',
              margin: '0',
            }}>
            <label className='petformlabel' style={{ width: '25%' }}>
              Age
            </label>
            <input
              value={petAge}
              placeholder='Age'
              onChange={(e) => {
                setPetAge(e.target.value);
              }}
              className='petform'
            />
          </div>
          <div
            style={{
              display: 'flex',
              width: '100%',
              paddingTop: '3%',
              margin: '0',
            }}>
            <label className='petformlabel' style={{ width: '25%' }}>
              Species
            </label>
            <input
              value={petSpecies}
              placeholder='Species'
              onChange={(e) => {
                setPetSpecies(e.target.value);
              }}
              className='petform'
            />
          </div>
          <div
            style={{
              display: 'flex',
              width: '100%',
              paddingTop: '3%',
              margin: '0',
            }}>
            <label className='petformlabel' style={{ width: '25%' }}>
              Color
            </label>
            <input
              value={petColor}
              placeholder='Color'
              onChange={(e) => {
                setPetColor(e.target.value);
              }}
              className='petform'
            />
          </div>
          <div
            style={{
              display: 'flex',
              width: '100%',
              paddingTop: '3%',
              margin: '0',
            }}>
            <label className='petformlabel' style={{ width: '25%' }}>
              Weight
            </label>
            <input
              value={petWeight}
              placeholder='Weight'
              onChange={(e) => {
                setPetWeight(e.target.value);
              }}
              className='petform'
            />
          </div>
          <div
            style={{
              display: 'flex',
              width: '100%',
              paddingTop: '3%',
              margin: '0',
            }}>
            <label className='petformlabel' style={{ width: '25%' }}>
              Tag
            </label>
            <input
              value={petTag}
              placeholder='Tag'
              onChange={(e) => {
                setPetTag(e.target.value);
              }}
              className='petform'
            />
          </div>

          {/* <TextField
          id='standard-basic'
          label='Name'
          value={petName}
          onChange={(e) => {
            setPetName(e.target.value);
          }}
        /> */}
          {/* <TextField
          id='standard-basic'
          label='Birthday'
          value={petBirthday}
          onChange={(e) => {
            setPetBirthday(e.target.value);
          }}
        /> */}
          {/* <TextField
          id='standard-basic'
          label='Age'
          value={petAge}
          onChange={(e) => {
            setPetAge(e.target.value);
          }}
        /> */}
          {/* <TextField
          id='standard-basic'
          label='Species'
          value={petSpecies}
          onChange={(e) => {
            setPetSpecies(e.target.value);
          }}
        /> */}
          {/* <TextField
          id='standard-basic'
          label='Color'
          value={petColor}
          onChange={(e) => {
            setPetColor(e.target.value);
          }}
        /> */}
          {/* <TextField
          id='standard-basic'
          label='Weight'
          value={petWeight}
          onChange={(e) => {
            setPetWeight(e.target.value);
          }}
        /> */}
          {/* <TextField
          id='standard-basic'
          label='Tag'
          value={petTag}
          onChange={(e) => {
            setPetTag(e.target.value);
          }}
        /> */}
          <div
            style={{
              width: '100%',
              textAlign: 'start',
              paddingTop: '5%',
              margin: '0',
            }}>
            <Button
              variant='contained'
              color='primary'
              // size='small'
              // style={{width:'30%'}}
              className={classes.button}
              onClick={() => Update()}>
              Update
            </Button>
          </div>
        </form>
      )}
      <br></br>
    </div>
  );
}

export default Profile;
